import produce from 'immer';

import {
	FETCH_APARTMENTS_PENDING,
	FETCH_APARTMENTS_FAILED,
	FETCH_APARTMENTS_FULFILLED
} from '../constants/apartments.actions';

import {
	SET_LOCATION_FILTERS_FULFILLED,
	SET_PRICE_FILTERS_FULFILLED,
	SET_ROOM_COUNT_FILTERS_FULFILLED,
	CLEAR_ALL_FILTERS_FULFILLED
} from '../constants/filters.actions';

import { arrangeFiltersFromApartments } from '../helpers/filters/filters';

const filtersReducer = produce(
	(draft, action) => {
		switch(action.type) {
			case FETCH_APARTMENTS_PENDING: {
				draft.loading = true;
				draft.error = false;
				break;
			}
			case FETCH_APARTMENTS_FAILED: {
				draft.loading = false;
				draft.error = true;
				break;
			}
			case FETCH_APARTMENTS_FULFILLED: {
				const filters = arrangeFiltersFromApartments(action.payload.apartments);
				draft.locations = filters.locations;
				draft.prices = filters.prices;
				draft.roomCount = filters.rooms;
				draft.loading = false;
				draft.error = false;
				break;
			}
			case SET_LOCATION_FILTERS_FULFILLED: {
				draft.selectedLocations = action.payload.filters;
				break;
			}
			case SET_PRICE_FILTERS_FULFILLED: {
				draft.selectedPrices = action.payload.filters;
				break;
			}
			case SET_ROOM_COUNT_FILTERS_FULFILLED: {
				draft.selectedRoomCount = action.payload.filters;
				break;
			}
			case CLEAR_ALL_FILTERS_FULFILLED: {
				draft.selectedLocations = [];
				draft.selectedPrices = [];
				draft.selectedRoomCount = [];
				break;
			}
			default: {
				break;
			}
		}
	},
	{
		selectedLocations: [],
		selectedPrices: [],
		selectedRoomCount: [],
		locations: [],
		prices: [],
		roomCount: [],
		loading: false,
		error: false
	}
);

export default filtersReducer;
